import apiClient from '@/lib/api-client'
import type { Chat, Message } from '@/types'

export const chatService = {
  async getChats(): Promise<Chat[]> {
    const response = await apiClient.get<Chat[]>('/api/v1/chat')
    return response.data
  },

  async getChat(id: string): Promise<Chat> {
    const response = await apiClient.get<Chat>(`/api/v1/chat/${id}`)
    return response.data
  },

  async createChat(title: string): Promise<Chat> {
    const response = await apiClient.post<Chat>('/api/v1/chat', { title })
    return response.data
  },

  async deleteChat(id: string): Promise<void> {
    await apiClient.delete(`/api/v1/chat/${id}`)
  },

  async sendMessage(chatId: string, content: string): Promise<Message> {
    const response = await apiClient.post<Message>(`/api/v1/chat/${chatId}/messages`, {
      content,
    })
    return response.data
  },

  async createGreetingMessage(
    chatId: string,
    content: string,
    msgMetadata?: Record<string, unknown>,
  ): Promise<Message> {
    const response = await apiClient.post<Message>(`/api/v1/chat/${chatId}/messages/greeting`, {
      role: 'assistant',
      content,
      channel: 'web',
      ...(msgMetadata ? { msg_metadata: msgMetadata } : {}),
    })
    return response.data
  },

  async getMessages(chatId: string, skip = 0, limit = 20): Promise<Message[]> {
    const response = await apiClient.get<Message[]>(`/api/v1/chat/${chatId}/messages`, {
      params: { skip, limit },
    })
    return response.data
  },
}
